import styled from 'styled-components'
import { clamp } from '../../styles/utils/conversion.style'
import { colors } from '../../styles/vars/colors.style'

export const AmenityMain = styled.li`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  ${props => {
    const minDiameter = props.compact ? 8 : 24
    const maxDiameter = props.compact ? 21 : 36

    return `
      ${clamp('padding-top', minDiameter, maxDiameter)}
      ${clamp('padding-bottom', minDiameter, maxDiameter)}
    `
  }}
`

export const AmenityLine = styled.span`
  background-color: ${colors.darkBlue};
  bottom: 0;
  content: '';
  display: block;
  height: 0.1rem;
  left: 0;
  position: absolute;
  right: 0;
  transform-origin: 0% 0%;
  will-change: opacity;
`

export const AmenityInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
`

export const AmenityIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => {
    if (props.align === 'left') return 'flex-start'
    if (props.align === 'right') return 'flex-end'
    return 'center'
  }};

  ${props => {
    const minDiameter =
      props.iconSize === 'small' ? 36 : props.iconSize === 'medium' ? 80 : 80
    const maxDiameter =
      props.iconSize === 'small' ? 48 : props.iconSize === 'medium' ? 96 : 120

    return `
      ${clamp('width', minDiameter, maxDiameter)}
    `
  }}

  img {
    width: 46%;
    max-width: ${props => `${props.maxWidth / 10}rem`};
  }
`

export const AmenityText = styled.div`
  ${props => {
    const minDiameter = props.align === 'left' ? 36 : 80
    const maxDiameter = props.align === 'left' ? 48 : 96

    return `
      ${clamp('padding-left', minDiameter, maxDiameter)}
    `
  }}

  * + & {
    margin-top: 1.4rem;
  }
`

export const AmenityTitle = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`
